import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames/bind";
// eslint-disable-next-line import/no-cycle
import { IconLinks } from "../../sharedComponents/IconLinks";
// eslint-disable-next-line import/no-cycle
import { RichText } from "../RichText";
import { cloudinaryImageToSrcUrlAdapter } from "../../sharedComponents/CloudinaryImageAdapter";
import { Icon } from "../Icons";
import { Cell, Row } from "../Grid";
import * as styles from "./IconLinks.module.scss";

const cx = classNames.bind(styles);

const IconContentSelection = ({
	links,
	columns,
	variant,
	className,
	customVariant,
	labels,
	language,
}) => {
	const localizePrice = price => {
		const priceRegex = new RegExp(/^\d+(\.\d{1,2})?$/);
		const isValidPrice = priceRegex.test(price);
		let newPrice = price.toString();

		if (isValidPrice) {
			const match = priceRegex.exec(price);
			if (match?.[1]?.length < 3) {
				newPrice = `${newPrice}0`;
			}

			if (language === "fr") {
				newPrice = newPrice.replace(".", ",");
			}
		} else {
			// Handle usecase where a terminating decimal could exist
			// eslint-disable-next-line prefer-destructuring
			newPrice = newPrice.split(".")[0];
		}

		const localized = language === "fr" ? `${newPrice} $` : `$${newPrice}`;
		return localized;
	};

	return (
		<div className={cx(className?.tileSection)}>
			<Row cols={columns} className={className?.row}>
				{links.map(item => (
					<Cell key={item.id} className={className?.column}>
						<IconLinks
							layout={variant !== "tilePricing" && "stack"}
							className={cx(
								!customVariant ? (styles.contentItem, styles.item) : styles.customStyle,
								variant
							)}
							to={item?.link?.url}
							target={item?.link?.target}>
							{(item?.icon || item?.iconName) && (
								<IconLinks.Icon
									icon={item.iconName || item.icon.name || item?.icon?.icon}
									className={cx(styles.icon, className?.icon)}
									title={item.link?.heading || item.link?.linkText || item.title}
									hidden
								/>
							)}
							{item?.image && (
								<IconLinks.Image
									url={cloudinaryImageToSrcUrlAdapter(item.image[0])}
									className={styles.img}
								/>
							)}
							<IconLinks.Title className={cx(styles.title)}>
								{item?.link?.heading || item?.link?.linkText || item?.displayTitle}{" "}
								{variant === "link" && <Icon name="arrow-thick" className="text-xs" />}
							</IconLinks.Title>
							{item?.link?.subHeading && (
								<IconLinks.Content className={styles?.content}>
									{item?.link?.subHeading}
								</IconLinks.Content>
							)}
							{item?.link?.content && (
								<IconLinks.Content className={styles?.content}>
									<RichText data={item?.link?.content} />
								</IconLinks.Content>
							)}
							{(item?.fromPrice || (item?.fromPrice && item?.toPrice) || item?.priceMessage) && (
								<IconLinks.Pricing className={styles?.sectionPricing}>
									<div className={styles.container}>
										{(item.fromPrice || (item.fromPrice && item.toPrice)) && (
											<div className={styles.pricing}>
												{item.fromPrice && (
													<div className={styles.from}>
														<span className={styles.label}>{labels.from}</span>
														<span className={styles.price}>{localizePrice(item.fromPrice)}</span>
													</div>
												)}
												{item.fromPrice && item.toPrice && (
													<>
														<div className={styles.connector} />
														<div className={styles.to}>
															<span className={styles.label}>{labels.to}</span>
															<span className={styles.price}>{localizePrice(item.toPrice)}</span>
														</div>
													</>
												)}
											</div>
										)}
										<div className={cx(styles.message, !item.toPrice && styles.centerAlign)}>
											{item.priceMessage}
										</div>
									</div>
								</IconLinks.Pricing>
							)}
						</IconLinks>
					</Cell>
				))}
			</Row>
		</div>
	);
};

IconContentSelection.propTypes = {
	links: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			icon: PropTypes.shape({
				link: PropTypes.shape({
					heading: PropTypes.string.isRequired,
					subHeading: PropTypes.string,
				}),
			}).isRequired,
		})
	).isRequired,
	columns: PropTypes.string,
	variant: PropTypes.string.isRequired,
	className: PropTypes.shape({
		icon: PropTypes.string,
		tileSection: PropTypes.string,
		column: PropTypes.string,
		row: PropTypes.string,
	}),
	customVariant: PropTypes.string,
	labels: PropTypes.object,
	language: PropTypes.string,
};

IconContentSelection.defaultProps = {
	className: undefined,
	columns: undefined,
	customVariant: undefined,
	labels: undefined,
	language: "en",
};

export default IconContentSelection;
export { IconContentSelection };
